/* eslint-disable prettier/prettier */
import React from 'react';
import {useSeasons} from "../../../hooks/seasons";
import {usePlayerFilterOptions} from "../FilterOptions/PlayerFilterOptions";
import countriesDictionaryEn from "../../../dictionaries/countries/en/countries.json";
import countriesDictionarySv from "../../../dictionaries/countries/sv/countries.json";
import positionsDictionaryEn from "../../../dictionaries/positions/en/positions.json";
import positionsDictionarySv from "../../../dictionaries/positions/sv/positions.json";

function Translate(phrase, en, sv) {
    let translation;
    let translationId;
    en.map((dictionaryEn) => {
        if (dictionaryEn.name === phrase) {
            translationId = dictionaryEn.id;
        }
    });
    sv.map((dictionarySv) => {
        if (dictionarySv.id === translationId ) {
            translation = dictionarySv.name;
        }
    });
    return translation ? translation : phrase;
}
function PlayersFilter({ playersStats, season, setSeason, orderBy, setOrderBy, team, setTeam, position, setPosition, nationality, setNationality, playerLimit, setPlayerLimit }) {
    const [seasons, loadingSeasons, errorSeasons] = useSeasons('desc');
    const [playerFilterOptions, loadingPlayerFilterOptions, errorPlayerFilterOptions] = usePlayerFilterOptions();
    let playerNationalities = new Set().add('Alla nationaliteter');
    let playerPositions = new Set().add('Alla positioner');
    let playerTeams = [];
    let playerTeamsSet = new Set();

    playersStats?.map((player) => {
        if (player.nationality) {
            playerNationalities.add(player.nationality)
        }
        if (player.position) {
            playerPositions.add(player.position)
        }
        if (player.teamAbbrv) {
            if (!playerTeamsSet.has(player.teamAbbrv)) {
                playerTeamsSet.add(player.teamAbbrv);
                playerTeams.push({
                    teamAbbrv: player.teamAbbrv,
                    teamDisplayName: player.teamDisplayName
                });
            }
        }
    });
    playerTeams.sort((a, b) => {
        a.teamDisplayName.toUpperCase();
        b.teamDisplayName.toUpperCase();
        return a.teamDisplayName.localeCompare(b.teamDisplayName);
    });
    playerTeams.unshift({
        teamAbbrv: 'Alla lag',
        teamDisplayName: 'Alla lag'
    });
    return (
        <div className="data-container__header">
            <div className="row px-4 pt-3 pb-2">
                <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Sorterat på</p>
                    <select
                        value={orderBy}
                        onChange={(e) => {
                            setOrderBy(e.target.value)
                            setPlayerLimit(20)
                        }}
                        className="select"
                    >
                        {playerFilterOptions?.map((option) => (
                            <option value={option?.key}>{option?.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Lag</p>
                    <select
                        value={team}
                        onChange={(e) => {
                            setTeam(e.target.value)
                            setPlayerLimit(20)
                        }}
                        className="select"
                    >
                        {playerTeams?.map(t => (
                            <option value={t.teamAbbrv}>{t.teamDisplayName}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Position</p>
                    <select
                        value={position}
                        onChange={(e) => {
                            setPosition(e.target.value)
                            setPlayerLimit(20)
                        }}
                        className="select"
                    >
                        {Array.from(playerPositions).map(position => (
                            <option value={position}>{position !== 'Alla positioner' ? Translate(position, positionsDictionaryEn, positionsDictionarySv) : 'Alla positioner'}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Nationalitet</p>
                    <select
                        value={nationality}
                        onChange={(e) => {
                            setNationality(e.target.value)
                            setPlayerLimit(20)
                        }}
                        className="select"
                    >
                        {Array.from(playerNationalities).map(nationality => (
                            <option value={nationality}>{nationality !== 'Alla nationaliteter' ? Translate(nationality, countriesDictionaryEn, countriesDictionarySv) : 'Alla nationaliteter'}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Säsong</p>
                    <select
                        value={season}
                        onChange={(e) => {
                            setSeason(e.target.value)
                            setPlayerLimit(20)
                        }}
                        className="select"
                    >
                        {seasons?.map((season) => (
                            (Number(season?.configSeasonStartYear) >= 2019) ?
                                <option value={season?.configSeasonStartYear}>{season?.configSeasonStartYear}</option> :
                                ''
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
export default PlayersFilter;